module.exports = {
  mode: 'staging',
  apiUrl: 'https://aapi.staging.wannasport.com/api',
  wsApiUrl: 'https://wsapi.staging.wannasport.com/api',
  googleApiKey: 'AIzaSyBixcFsmrOmqHGAvxyWD4kwC4CGc0l-AtY',
  googleLoginClientId: '1069111212197-59ovsv7rp1dnskgeksh9leu5svvuvnvb.apps.googleusercontent.com',
  intercomAppId: '',
  adyen: {
    domain: 'ca-test.adyen.com'
  }
};